import { render } from "./UpdateServiceModal.vue?vue&type=template&id=4fd94bb4"
import script from "./UpdateServiceModal.vue?vue&type=script&lang=js"
export * from "./UpdateServiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__